<template>
  <nav
    class="navbar is-fixed-top"
    :class="color"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="container" :class="{ 'is-fluid': !inContainer }">
      <div class="navbar-brand">
        <a href="/" class="navbar-item">
          <img
            v-if="$store.getters.logo"
            class="mr-3"
            :src="$store.getters.logo"
            style="height: 30px"
          />

          <span
            v-else
            class="mr-2 has-text-grey-darker"
            style="font-weight: bold;font-size: 18px;font-family: 'Prompt', sans-serif;">
            {{ $store.state.config.app.name }}
          </span>

          <span
            v-if="$store.getters.isNotProduction"
            class="tag is-warning has-text-weight-bold"
          >
            {{ $store.state.config.app.environment.toUpperCase() }}
          </span>
        </a>

        <a :href="link()" class="navbar-item button" style="margin-top: 10px;">
          <i class="mdi mdi-link mdi-18px" style="margin-right: 5px;"></i>
          Go to new admin
        </a>

        <button class="button navbar-burger" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <div class="navbar-menu" :class="{ 'is-active': menuActive }">
        <div class="navbar-end">
          <user-navbar-item
            v-if="$store.getters.signedIn"
            :user="$store.state.auth.user"
          ></user-navbar-item>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import i18n from "./../i18n";
import UserNavbarItem from "./UserNavbarItem";

export default {
  i18n,

  components: {
    UserNavbarItem,
  },

  props: {
    color: {
      type: String,
      default: "is-white",
    },

    inContainer: {
      type: Boolean,
      default: false,
    },

    withLocaleSwitcher: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      menuActive: false,
    };
  },

  computed: {
    locale() {
      return i18n.locale;
    },

    env() {
      return window.location.href.includes("dev") ? "DEV" : "PROD";
    },
  },

  methods: {
    toggleMenu() {
      // this.menuActive = !this.menuActive;
      this.$root.$emit("toggleMenu");
    },

    setLocale(locale) {
      i18n.locale = locale;
    },

    link() {
      return `${this.$store.getters.kytebaseBaseURl}/manage/`;
    },
  },
};
</script>
